const externalRules = {
  required: (value) => {
    if (value instanceof Array && value.length === 0) {
      return 'Required.';
    }
    return !!value || 'Required.';
  },
  requiredId: (value) => !!value.id || 'Required.',
  counter: (value) => value.length <= 20 || 'Max 20 characters',
  email: (value) => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || 'Invalid e-mail.';
  },
  negative: (value) => value >= 0 || 'Can`t be negative',
  time: (value) => {
    const pattern = /^\d{1,5}:\d{1,2}:\d{1,2}$/;
    return pattern.test(value) || 'Time should be in format HH:MM:SS';
  },
  minScore: (value) => value >= 0 || 'Min score - 0.',
  maxScore: (value) => value <= 100 || 'Max score - 100.',
  positive: (value) => value >= 0 || 'Value can`t be lower than 0.',
  password: (value) => {
    const pattern = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return pattern.test(value) || 'Password requirements: uppercase and lowercase letter, numeric character (0-9) and special character (!@#…)';
  },
};

export default externalRules;
